import React from 'react'
import PropTypes from 'prop-types'
import { ButtonGroup, Button } from '@material-ui/core'

class CategoryFilter extends React.Component {
  handleChange(category) {
    if (this.props.category === category) {
      this.props.onChange(undefined)
    } else {
      this.props.onChange(category)
    }
  }
  render() {
    return (
      <ButtonGroup
        disableFocusRipple
        color="primary"
      >
        <Button
          variant={this.props.category === 'Public' ? 'contained' : 'outlined'}
          onClick={() => this.handleChange('Public')}
        >
          Public
        </Button>
        <Button
          variant={this.props.category === 'Private' ? 'contained' : 'outlined'}
          onClick={() => this.handleChange('Private')}
        >
          Private
        </Button>
      </ButtonGroup>
    )
  }
}
CategoryFilter.propTypes = {
  category: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default CategoryFilter
